import { z } from "zod";
export const ListSheetsParamsSchema = z.object({
    listSheets: z
        .array(z.object({}))
        .optional()
        .describe("Optional placeholder array. If omitted, defaults to [{}]."),
    sessionId: z.string().optional().describe("Backend session ID (injected automatically)"),
});
export { ListSheetsParamsSchema as ListSheetsToolParamsSchema };
